import { NoteBlock } from "../block";

export interface PushConnectorBlock extends NoteBlock {
  type: "omega/query-omega/page/block/push-connector/PushConnectorBlock";
  "push-con-id": string;
}

export function isPushConnectorBlock(
  block: NoteBlock
): block is PushConnectorBlock {
  return (block as PushConnectorBlock)["push-con-id"] !== undefined;
}
